var map = {
	"./class-attendance-report/locales/en.json": "260c",
	"./class-attendance-report/locales/kh.json": "04ed",
	"./class-attendance-v2/locales/en.json": "c2fc",
	"./class-attendance-v2/locales/kh.json": "a748",
	"./fee-predefine-item/locales/en.json": "c657",
	"./fee-predefine-item/locales/kh.json": "1dad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43e2";